/** Values callers may throw or reject with. */
export type CaughtError = Error | string;

/**
 * Map a `catch` or `.catch()` binding to a user-visible message.
 * Generic `E` accepts the implicit catch type without annotating `unknown`.
 */
export function guardiansErrorMessage<E>(err: E, fallback: string): string {
  if (err instanceof Error) return err.message || fallback;
  if (typeof err === "string" && err.length > 0) return err;
  return fallback;
}
